import React from "react";

export default function Main({ children }) {
  return <div className="main">{children}</div>;
}
